function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.array.some.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { CheckoutApiService } from "./Services/CheckoutApiService";
import { InnerPageBuilder } from "./Helpers/InnerPageBuilder";
import { UserService } from "./Services/UserService";
import { UrlHelper } from "./Helpers/UrlHelper";
import { Configuration } from "./Shared/Configuration";
export var MppCheckout = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppCheckout, _ComponentBase);

  var _super = _createSuper(MppCheckout);

  function MppCheckout() {
    _classCallCheck(this, MppCheckout);

    return _super.call(this);
  }

  _createClass(MppCheckout, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {
      if (!!this._$detailsContainer) {
        this.LoadAttributes();
        this.LoadInvoice();
      }
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _mppWidgetsConfigValu,
            _mppWidgetsConfigValu2,
            _this = this;

        var mppWidgetsConfigValues;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.LoadLabels();

              case 2:
                this._i18n = _context.sent;
                this.LoadAttributes();
                _context.next = 6;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 6:
                mppWidgetsConfigValues = _context.sent;
                this._invoiceDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.invoiceDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id";
                this._eventDetailIdParameterName = (_mppWidgetsConfigValu2 = mppWidgetsConfigValues.eventDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu2 !== void 0 ? _mppWidgetsConfigValu2 : "id";
                this._eventDetailIdParameterName = "?" + this._eventDetailIdParameterName + "="; // Root html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div id="spinner"><i class="mppw-spinner"></i></div><div id="backToEventContainer"></div><h1 id="pageTitle">Checkout</h1><p id="pageInstructions"></p><br/><form id="invoiceForm" class="mppw-form mppw-form-validate"><input type="hidden" id="field_eventId" name="field_eventId"/><div><h3>Invoice Details</h3><div class="mppw-form-field-alt"><div class="invoice-form__control"><table id="productsTable" class="mppw-invoice"><thead><tr><th>${this._i18n.productQtyLabel}</th><th class="align-text-left">${this._i18n.productDescriptionLabel}</th><th class="align-text-left">${this._i18n.productRegistrantLabel}</th><th class="align-text-right">${this._i18n.productPriceLabel}</th></tr></thead><tbody id="productsBody"></tbody><tfoot><tr id="totalCostRow"><td></td><td></td><td class="mppw-invoice-summary-label">${this._i18n.productTotalCostLabel}</td><td class="mppw-invoice-total"><span id="totalLabel">0.00</span></td></tr><tr id="amountPaidRow"><td></td><td></td><td class="mppw-invoice-summary-label">${this._i18n.productAmountPaidLabel}</td><td class="mppw-invoice-total"><span id="amountPaidLabel">0.00</span></td></tr><tr id="amountDueRow"><td></td><td></td><td id="amountDueLabel" class="mppw-invoice-summary-label">${this._i18n.productRemainingBalanceLabel}</td><td id="amountDueTotal" class="mppw-invoice-total"><span id="balanceDueLabel" style="display: none;">0.00</span></td></tr></tfoot></table></div></div></div><div id="paymentOptionsContainer"><h3>${this._i18n.paymentOptionsHeader}</h3><div class="mppw-form-field-alt"><div class="payment-options-control"><table id="paymentOptionsTable" class="mppw-product-options"><tbody id="paymentOptionsBody"><tr id="depositOptionRow"><td class="option-name"><label class="product-selection-container pointer-cursor"><input type="radio" class="product-radio" id="depositOption" name="paymentOption" value="deposit"> <span class="mppw-radio"></span> ${this._i18n.depositOptionDescription} - $<span id="depositAmount">0.00</span> <span class="mppw-payment-option-info-icon"></span> <span class="payment-option-description">${this._i18n.depositOptionInfo}</span></label></td></tr><tr><td class="option-name"><label class="product-selection-container pointer-cursor"><input type="radio" class="product-radio" id="fullOption" name="paymentOption" value="full"> <span class="mppw-radio"></span> <label id="totalCostLabel"></label> - $<span id="totalCost">0.00</span></label></td></tr><tr><td class="option-name"><label class="product-selection-container pointer-cursor"><input type="radio" class="product-radio" id="otherOption" name="paymentOption" value="other"> <span class="mppw-radio"></span> ${this._i18n.otherAmountDescription} <input type="number" id="otherAmount" name="otherAmount" placeholder="${this._i18n.otherAmountPlaceholder}" disabled="disabled" step="1.00" min="0"/></label><div id="otherAmountErrorContainer" class="mppw-error-message" style="display: none;"></div></td></tr></tbody></table></div></div></div><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div><button type="button" id="makeChanges" class="mppw-btn primary mpp-mt-10 submit--btn">${this._i18n.makeChangesButtonLabel}</button> <button type="button" id="payInvoice" class="mppw-btn primary mpp-mt-10 submit--btn">${this._i18n.invoicePayNowButtonLabel}</button></form></div>` ;
                this.BindHtmlElements();
                this._currentUrl = new URL(window.location.href);
                this._invoiceGuid = this._currentUrl.searchParams.get(this._invoiceDetailWidgetIdParameterName);

                if (!this._invoiceGuid) {
                  this._invoiceGuid = this._currentUrl.searchParams.get("id");
                }

                this._paymentResponseToken = this._currentUrl.searchParams.get("token");
                this.ShowSpinner(); // JwtToken takes priority over id guid, it should also contain the invoice guid in the response

                if (!!this._paymentResponseToken) {
                  this.ProcessPaymentResponse(this._paymentResponseToken).then(function (results) {
                    if (!!results.success) {
                      _this.SetMessage("success", _this._i18n.paymentComplete);

                      _this._$makeChangesButton.style.display = "none";
                    } else {
                      if (!!results.paymentReceived && !results.paymentNotified) {
                        _this.SetMessage("danger", _this._i18n.pendingNotification);

                        _this._$payInvoiceButton.disabled = true;
                        _this._$makeChangesButton.style.display = "none";
                      } else {
                        _this.SetMessage("danger", _this._i18n.paymentFailed);
                      }
                    } // Load invoice details


                    _this._invoiceGuid = results.invoiceId;

                    _this.LoadInvoice(results.invoiceId, true);
                  })["catch"](function (error) {
                    _this.HideForm();

                    _this.SetMessage("danger", _this.GetI18NMessageByName(error.Details) || _this._i18n.unknownError);
                  });
                } else {
                  if (!!this._invoiceGuid) {
                    // Setup initial invoice/checkout screen
                    this.LoadInvoice(this._invoiceGuid, false);
                  } else {
                    this.HideForm();
                    this.SetMessage("warning", "Unable to display invoice");
                    this._$pageInstructions.innerHTML = this._i18n.unableToFindInvoiceMessage;
                  }
                }

                this.HideSpinner();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$spinner = this._root.querySelector("#spinner");
      this._$invoiceForm = this._root.querySelector("#invoiceForm");
      this._$pageTitle = this._root.querySelector("#pageTitle");
      this._$pageInstructions = this._root.querySelector("#pageInstructions");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$totalLabel = this._root.querySelector("#totalLabel");
      this._$amountPaidLabel = this._root.querySelector("#amountPaidLabel");
      this._$balanceDueLabel = this._root.querySelector("#balanceDueLabel");
      this._$amountDueTotal = this._root.querySelector("#amountDueTotal");
      this._$amountDueLabel = this._root.querySelector("#amountDueLabel");
      this._$payInvoiceButton = this._root.querySelector("#payInvoice");
      this._$makeChangesButton = this._root.querySelector("#makeChanges");
      this._$productsBody = this._root.querySelector("#productsBody");
      this._$backToEventContainer = this._root.querySelector("#backToEventContainer");
      this._$otherAmount = this._root.querySelector("#otherAmount");
      this._$otherOption = this._root.querySelector("#otherOption");
      this._$otherAmountErrorContainer = this._root.querySelector("#otherAmountErrorContainer");
      this._$depositOption = this._root.querySelector("#depositOption");
      this._$fullOption = this._root.querySelector("#fullOption");
      this._$depositAmount = this._root.querySelector("#depositAmount");
      this._$totalCost = this._root.querySelector("#totalCost");
      this._$amountPaidRow = this._root.querySelector("#amountPaidRow");
      this._$totalCostRow = this._root.querySelector("#totalCostRow");
      this._$amountDueRow = this._root.querySelector("#amountDueRow");
      this._$paymentOptionsContainer = this._root.querySelector("#paymentOptionsContainer");
      this._$depositOptionRow = this._root.querySelector("#depositOptionRow");
      this._$totalCostLabel = this._root.querySelector("#totalCostLabel");
    }
  }, {
    key: "LoadAttributes",
    value: function LoadAttributes() {
      this.paymentProcessorTargetUrl = this.getAttribute("paymentprocessortargeturl");
      this.backToEventTargetUrl = this.getAttribute("backtoeventtargeturl");
      this.receiptTemplateId = this.getAttribute("receipttemplateid");

      if (!this.paymentProcessorTargetUrl) {
        this.SetMessage('warning', "Required values to transact payment are not configured. Please contact your system administrator.");
      }
    }
  }, {
    key: "LoadLabels",
    value: function () {
      var _LoadLabels = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new I18N(MppCheckout.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this2._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this2._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function LoadLabels() {
        return _LoadLabels.apply(this, arguments);
      }

      return LoadLabels;
    }()
  }, {
    key: "GetI18NMessageByName",
    value: function GetI18NMessageByName(name) {
      var keys = Object.keys(this._i18n);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (key === name) {
          return this._i18n[key];
        }
      }
    }
  }, {
    key: "ProcessPaymentResponse",
    value: function ProcessPaymentResponse(paymentResponseToken) {
      var formData = new FormData();
      formData.append("text", paymentResponseToken);
      var checkoutService = new CheckoutApiService();
      return checkoutService.ProcessPaymentResponse(formData);
    } // fromPaymentProcessor true/false if coming from payment page

  }, {
    key: "LoadInvoice",
    value: function LoadInvoice(invoiceGuid, fromPaymentProcessor) {
      var _this3 = this;

      var checkoutService = new CheckoutApiService();
      checkoutService.GetInvoice(invoiceGuid).then(function (invoiceData) {
        _this3._InvoiceData = invoiceData;

        _this3._UpdateUI();

        _this3._UpdateEventDetailsVisibility(fromPaymentProcessor);

        _this3.BindEventListeners();
      })["catch"](function (error) {
        _this3.SetMessage("danger", _this3._i18n.unableToFindInvoiceMessage);

        _this3.HideForm();

        _this3._$pageInstructions.innerHTML = _this3._i18n.unableToFindInvoiceMessage;
      });
    }
  }, {
    key: "_UpdateUI",
    value: function _UpdateUI() {
      var _this4 = this;

      var _this$_InvoiceData = this._InvoiceData,
          invoiceTotal = _this$_InvoiceData.invoiceTotal,
          amountPaid = _this$_InvoiceData.amountPaid,
          balanceDetails = _this$_InvoiceData.balanceDetails,
          detailItems = _this$_InvoiceData.detailItems;
      this._$totalLabel.innerHTML = invoiceTotal.toFixed(2);
      this._$amountPaidLabel.innerHTML = amountPaid.toFixed(2);
      this._somePaid = amountPaid > 0;
      this._balanceDue = Number(parseFloat(balanceDetails.balanceDue).toFixed(2));
      this._$productsBody.innerHTML = detailItems.map(function (item) {
        return _this4.BuildProductsBodyHtml(item);
      }).join('');

      this._UpdateBalanceDueLabel();

      this._UpdateButtonVisibility();

      this._DisplayDepositAmount();

      this._UpdateInvoiceDisplayStyles();

      this._UpdatePaymentOptionsVisibility();

      this._UpdateTotalCostDisplay();
    }
  }, {
    key: "_UpdateButtonVisibility",
    value: function _UpdateButtonVisibility() {
      var _this$_InvoiceData2 = this._InvoiceData,
          balanceDetails = _this$_InvoiceData2.balanceDetails,
          canUserPayInvoice = _this$_InvoiceData2.canUserPayInvoice;
      this._$payInvoiceButton.style.display = balanceDetails.balanceDue > 0 && canUserPayInvoice ? "inline-block" : "none";

      var shouldHideMakeChangesButton = this._ShouldHideMakeChangesButton();

      if (shouldHideMakeChangesButton) {
        this._$makeChangesButton.style.display = "none";
      } else {
        this._$makeChangesButton.style.display = "inline-block";
      }

      this._UpdateStatusMessages();
    }
  }, {
    key: "_ShouldHideMakeChangesButton",
    value: function _ShouldHideMakeChangesButton() {
      var status = this._InvoiceData.status;
      var balanceDue = this._balanceDue;
      return status === 2 || this._somePaid || balanceDue <= 0;
    }
  }, {
    key: "_UpdateBalanceDueLabel",
    value: function _UpdateBalanceDueLabel() {
      var balanceDue = this._balanceDue;
      this._$balanceDueLabel.innerHTML = balanceDue.toFixed(2);
      this._$balanceDueLabel.style.display = "block";
    }
  }, {
    key: "_UpdateEventDetailsVisibility",
    value: function _UpdateEventDetailsVisibility(fromPaymentProcessor) {
      var _this$_InvoiceData3 = this._InvoiceData,
          detailItems = _this$_InvoiceData3.detailItems,
          balanceDetails = _this$_InvoiceData3.balanceDetails,
          invoiceGuid = _this$_InvoiceData3.invoiceGuid;
      var totalAmountDue = balanceDetails.balanceDue;

      if (fromPaymentProcessor || totalAmountDue <= 0) {
        var eventId = !!detailItems && detailItems.length > 0 ? detailItems[0].eventId : null;

        if (!!eventId) {
          this._$backToEventContainer.innerHTML = InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(this._i18n.backToEventDetailsLabel, "".concat(this.backToEventTargetUrl).concat(this._eventDetailIdParameterName).concat(eventId, "&invoiceid=").concat(invoiceGuid)));
          this._$backToEventContainer.style.display = "block";
        } else {
          this._$backToEventContainer.style.display = "none";
        }
      } else {
        this._$backToEventContainer.style.display = "none";
      }
    }
  }, {
    key: "_UpdateStatusMessages",
    value: function _UpdateStatusMessages() {
      var depositDetails = this._InvoiceData.depositDetails; // Determine if deposit is requested across all relevant scenarios

      var depositRequested = this._CheckDepositRequested(); // Simplify conditions by assigning them to descriptively named variables


      var isDepositPaid = depositDetails.isDepositPaid;
      var balanceDue = this._balanceDue > 0;
      var hasPaymentBeenMade = this._somePaid; // Apply logic to determine which title and subtitle to display

      if (isDepositPaid && depositRequested || hasPaymentBeenMade && isDepositPaid && balanceDue) {
        this._UpdatePageTitleContent('payRemainingBalanceTitle', 'payRemainingBalanceSubtitle');
      } else if (balanceDue) {
        this._UpdatePageTitleContent('reviewAndPayTitle', 'reviewAndPaySubtitle');
      } else {
        this._UpdatePageTitleContent('registrationCompleteTitle', 'registrationCompleteSubtitle');
      }
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this5 = this;

      this._$payInvoiceButton.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  event.preventDefault();
                  _context3.prev = 1;
                  _context3.next = 4;
                  return _this5.PayInvoice();

                case 4:
                  _context3.next = 9;
                  break;

                case 6:
                  _context3.prev = 6;
                  _context3.t0 = _context3["catch"](1);
                  console.error("Error paying invoice:", _context3.t0);

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[1, 6]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

      this._$makeChangesButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (_this5._InvoiceData.detailItems !== null && _this5._InvoiceData.detailItems.length > 0) {
          window.location.href = _this5.backToEventTargetUrl + _this5._eventDetailIdParameterName + _this5._InvoiceData.detailItems[0].eventId + "&invoiceid=" + _this5._invoiceGuid;
        }
      }); // Event listener for payment options change


      var paymentOptions = this._root.querySelectorAll("input[name='paymentOption']");

      paymentOptions.forEach(function (option) {
        return option.addEventListener("change", _this5._OnPaymentOptionChanged.bind(_this5));
      }); // Initial call to set the correct state when the page loads

      this._OnPaymentOptionChanged();
    }
  }, {
    key: "DeleteEventRegistration",
    value: function DeleteEventRegistration(invoiceDetailId) {
      var _this6 = this;

      var checkoutApiService = new CheckoutApiService();
      checkoutApiService.DeleteEventRegistration(invoiceDetailId).then(function (result) {
        // Refresh page
        if (result.success === true) {
          window.location.reload(true);
        } else {
          _this6.SetMessage("warning", result.message || _this6._i18n.unableToDeleteRegistrationMessage);
        }
      })["catch"](function (error) {
        _this6.SetMessage("danger", error);
      });
    }
  }, {
    key: "PayInvoice",
    value: function () {
      var _PayInvoice = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this$_GetPaymentDeta, amountToPay, paymentOption, checkoutApiService, returnUrl, jwtToken, paymentUrl, errorMessage;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$_GetPaymentDeta = this._GetPaymentDetails(), amountToPay = _this$_GetPaymentDeta.amountToPay, paymentOption = _this$_GetPaymentDeta.paymentOption;

                if (this._ValidateAmountDue(amountToPay)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                // Generate jwt token and pass to pay endpoint
                checkoutApiService = new CheckoutApiService();
                returnUrl = "".concat(this._currentUrl.protocol, "//").concat(this._currentUrl.host).concat(this._currentUrl.pathname);
                this.HideMessage();
                _context4.prev = 6;
                _context4.next = 9;
                return checkoutApiService.BuildPaymentRequestToken(this._invoiceGuid, this.paymentProcessorTargetUrl, returnUrl, amountToPay, paymentOption);

              case 9:
                jwtToken = _context4.sent;

                if (!jwtToken) {
                  _context4.next = 25;
                  break;
                }

                _context4.prev = 11;
                _context4.next = 14;
                return this.BuildPaymentUrl(jwtToken.token);

              case 14:
                paymentUrl = _context4.sent;
                window.location.href = paymentUrl;
                _context4.next = 25;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](11);
                console.error("Error building payment URL:", _context4.t0);
                errorMessage = this._i18n.cannotPayInvoiceLabel;

                if (typeof _context4.t0 === "string") {
                  errorMessage += " " + _context4.t0;
                }

                this.SetMessage("danger", errorMessage);
                this._$payInvoiceButton.style.display = "none";

              case 25:
                _context4.next = 32;
                break;

              case 27:
                _context4.prev = 27;
                _context4.t1 = _context4["catch"](6);
                console.error("Error building payment request token:", _context4.t1);
                this.SetMessage("danger", this._i18n.cannotPayInvoiceLabel);
                this._$payInvoiceButton.style.display = "none";

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 27], [11, 18]]);
      }));

      function PayInvoice() {
        return _PayInvoice.apply(this, arguments);
      }

      return PayInvoice;
    }()
  }, {
    key: "_GetSelectedPaymentOption",
    value: function _GetSelectedPaymentOption() {
      return this._root.querySelector('input[name="paymentOption"]:checked');
    }
  }, {
    key: "_GetSelectedPaymentAmount",
    value: function _GetSelectedPaymentAmount(selectedOption) {
      var amountToPay = 0;

      if (selectedOption.value === "deposit") {
        amountToPay = parseFloat(this._$depositAmount.textContent);
      } else if (selectedOption.value === "full") {
        amountToPay = parseFloat(this._$totalCost.textContent);
      } else if (selectedOption.value === "other") {
        amountToPay = parseFloat(this._$otherAmount.value);
      }

      return amountToPay;
    }
    /**
     * Displays a message to the user.
     * @param {string} status The message type (e.g., "danger", "success").
     * @param {string} messageKeyOrText The key for the message in the i18n object or direct message text.
     * @param {Array} replaceValues (Optional) Values to replace in the message text.
     */

  }, {
    key: "SetMessage",
    value: function SetMessage(status, messageKeyOrText) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      var message = this._i18n[messageKeyOrText] || messageKeyOrText;

      for (var _len = arguments.length, replaceValues = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        replaceValues[_key - 2] = arguments[_key];
      }

      replaceValues.forEach(function (value, index) {
        // Ensure `message` is a string that can have `.replace` called on it safely
        if (typeof message === 'string') {
          message = message.replace(new RegExp("\\{".concat(index, "\\}"), 'g'), String(value));
        }
      });
      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "_ShowOtherAmountError",
    value: function _ShowOtherAmountError(messageKey) {
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var message = this._i18n[messageKey];

      if (message && amount !== null) {
        // Safely call replace only if message is found and amount is not null
        message = message.replace('[amount]', amount.toFixed(2));
      } else {
        // Fallback message if key not found or amount is null
        message = message || "An error occurred.";
      }

      this._$otherAmountErrorContainer.textContent = message;
      this._$otherAmountErrorContainer.style.display = "block";
    }
  }, {
    key: "_ValidateAmount",
    value: function _ValidateAmount(amount, constraints) {
      var minimum = constraints.minimum,
          maximum = constraints.maximum,
          isDepositRequired = constraints.isDepositRequired,
          minimumDeposit = constraints.minimumDeposit,
          status = constraints.status;
      if (amount === null) return {
        isValid: false,
        messageKey: 'selectPaymentOptionPrompt'
      };else if (isNaN(amount)) {
        return {
          isValid: false,
          messageKey: 'validAmountPrompt'
        };
      } else if (amount < minimum && !isDepositRequired) {
        return {
          isValid: false,
          messageKey: 'amountDueMinimum'
        };
      } else if (amount > this._balanceDue && !isDepositRequired) {
        return {
          isValid: false,
          messageKey: 'amountDueMaximum'
        };
      } else if (isDepositRequired && amount < minimumDeposit && status !== 2) {
        return {
          isValid: false,
          messageKey: 'minimumDepositRequired',
          amount: minimumDeposit
        };
      } else if (isDepositRequired && amount > maximum) {
        return {
          isValid: false,
          messageKey: 'maximumAmountExceeded',
          amount: maximum
        };
      }
      return {
        isValid: true
      };
    }
  }, {
    key: "_ValidateAmountDue",
    value: function _ValidateAmountDue(amountToPay) {
      var constraints = this._GeneratePaymentValidationConstraints();

      var validation = this._ValidateAmount(amountToPay, constraints);

      if (!validation.isValid) {
        // Ensure messageParams is an array before spreading
        var messageParams = Array.isArray(validation.messageParams) ? validation.messageParams : [];
        this.SetMessage.apply(this, ["danger", validation.messageKey].concat(_toConsumableArray(messageParams)));
        return false;
      }

      return true;
    }
  }, {
    key: "_ValidateOtherAmount",
    value: function _ValidateOtherAmount() {
      var enteredAmount = parseFloat(this._$otherAmount.value);

      var constraints = this._GeneratePaymentValidationConstraints();

      var validation = this._ValidateAmount(enteredAmount, constraints);

      if (!validation.isValid) {
        this._ShowOtherAmountError(validation.messageKey, validation.amount);

        this._$otherAmount.classList.add('mppw-invalid');
      } else {
        this._ClearOtherAmountError();
      }
    } // Clearing error messages for other amount

  }, {
    key: "_ClearOtherAmountError",
    value: function _ClearOtherAmountError() {
      this._$otherAmountErrorContainer.textContent = '';
      this._$otherAmountErrorContainer.style.display = "none";

      this._$otherAmount.classList.remove('mppw-invalid');
    }
  }, {
    key: "BuildPaymentUrl",
    value: function () {
      var _BuildPaymentUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(jwt) {
        var userInfo;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._VerifyLogin();

              case 2:
                userInfo = _context5.sent;
                return _context5.abrupt("return", UrlHelper.AddQueryParameter(UrlHelper.BuildUserUrl(this.paymentProcessorTargetUrl, userInfo), "token", jwt));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function BuildPaymentUrl(_x2) {
        return _BuildPaymentUrl.apply(this, arguments);
      }

      return BuildPaymentUrl;
    }()
  }, {
    key: "_VerifyLogin",
    value: function () {
      var _VerifyLogin2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var userInfo;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return UserService.GetCurrentUser();

              case 3:
                userInfo = _context6.sent;

                if (!userInfo) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", userInfo);

              case 6:
                _context6.next = 10;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

              case 10:
                return _context6.abrupt("return", null);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 8]]);
      }));

      function _VerifyLogin() {
        return _VerifyLogin2.apply(this, arguments);
      }

      return _VerifyLogin;
    }()
  }, {
    key: "BuildProductsBodyHtml",
    value: function BuildProductsBodyHtml(invoiceData) {
      return "<tr>\n\t\t\t\t<td class=\"mppw-invoice-qty\">".concat(invoiceData.quantity, "</td>\n\t\t\t\t<td>").concat(invoiceData.itemName, "</td>\n\t\t\t\t<td>").concat(invoiceData.recipientName, "</td>\n\t\t\t\t<td class=\"mppw-invoice-line-total\">").concat(invoiceData.lineTotal.toFixed(2), "</td>\n\t\t\t\t</tr>\n\t\t\t");
    }
  }, {
    key: "ShowForm",
    value: function ShowForm() {
      this._ToggleRowVisibility(this._$invoiceForm, true);
    }
  }, {
    key: "HideForm",
    value: function HideForm() {
      this._ToggleRowVisibility(this._$invoiceForm, false);
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }, {
    key: "ShowSpinner",
    value: function ShowSpinner() {
      this._ToggleRowVisibility(this._$spinner, true);
    }
  }, {
    key: "HideSpinner",
    value: function HideSpinner() {
      this._ToggleRowVisibility(this._$spinner, false);
    }
  }, {
    key: "_OnPaymentOptionChanged",
    value: function _OnPaymentOptionChanged() {
      // Check if "Other" option is selected
      var isOtherSelected = this._$otherOption.checked; // Enable or disable the otherAmount text box based on the selection

      this._$otherAmount.disabled = !isOtherSelected; // Clear any previous error message

      this._$otherAmountErrorContainer.textContent = '';
      this._$otherAmountErrorContainer.style.display = "none";

      if (isOtherSelected) {
        // Validate the entered amount
        this._$otherAmount.addEventListener('input', this._ValidateOtherAmount.bind(this));
      } else {
        // Clear the otherAmount text box when not selected
        this._$otherAmount.value = '';
      }
    }
  }, {
    key: "_DisplayDepositAmount",
    value: function _DisplayDepositAmount() {
      var depositDetails = this._InvoiceData.depositDetails;

      if (this._$depositAmount) {
        this._$depositAmount.innerHTML = depositDetails.depositTotal.toFixed(2);
      }
    }
  }, {
    key: "_UpdateDepositOptionRowVisibility",
    value: function _UpdateDepositOptionRowVisibility(status, depositDetails, amountPaid) {
      var shouldHideDepositOptionRow = status === 2 || depositDetails.isDepositPaid || !depositDetails.hasDepositAmount || amountPaid > 0;

      this._ToggleRowVisibility(this._$depositOptionRow, !shouldHideDepositOptionRow);
    }
  }, {
    key: "_UpdateInvoiceDisplayStyles",
    value: function _UpdateInvoiceDisplayStyles() {
      var status = this._InvoiceData.status; // Determine if rows should be highlighted

      var shouldHighlight = this._somePaid || status === 2; // Always show totalCostRow, but adjust weight based on conditions

      this._SetRowFontWeight(this._$totalCostRow, shouldHighlight ? 'normal-weight' : 'bold-weight'); // Apply conditional visibility and styles to amountPaidRow and amountDueRow


      this._ToggleRowVisibility(this._$amountPaidRow, shouldHighlight, 'normal-weight');

      this._ToggleRowVisibility(this._$amountDueRow, shouldHighlight, 'bold-weight');
    }
    /**
     * Toggles the visibility of a table row element.
     * @param {HTMLElement} rowElement - The table row element to be styled.
     * @param {boolean} shouldDisplay - Determines if the row should be displayed (true) or hidden (false).
     * @param {string} [fontWeightClass] - The CSS class for the font weight. If provided, it will be applied to the row.
     */

  }, {
    key: "_ToggleRowVisibility",
    value: function _ToggleRowVisibility(rowElement, shouldDisplay, fontWeightClass) {
      rowElement.style.display = shouldDisplay ? '' : 'none';

      if (!!fontWeightClass) {
        this._SetRowFontWeight(rowElement, fontWeightClass);
      }
    }
    /**
     * Sets the font weight class of a table row element.
     * @param {HTMLElement} rowElement - The table row element to apply the font weight class.
     * @param {string} fontWeightClass -  The CSS class for the font weight to be applied to the row.
     */

  }, {
    key: "_SetRowFontWeight",
    value: function _SetRowFontWeight(rowElement, fontWeightClass) {
      // Reset classes to ensure only the relevant style is applied
      rowElement.classList.remove('normal-weight', 'bold-weight'); // Apply new class for font weight

      rowElement.classList.add(fontWeightClass);
    }
  }, {
    key: "_UpdatePaymentOptionsVisibility",
    value: function _UpdatePaymentOptionsVisibility() {
      var _this$_InvoiceData4 = this._InvoiceData,
          depositDetails = _this$_InvoiceData4.depositDetails,
          invoiceTotal = _this$_InvoiceData4.invoiceTotal,
          amountPaid = _this$_InvoiceData4.amountPaid,
          status = _this$_InvoiceData4.status;
      var balanceDue = this._balanceDue;

      var shouldShowPaymentOptions = this._ShouldShowPaymentOptions(depositDetails, invoiceTotal, balanceDue, amountPaid); // Apply styles based on whether we should show payment options


      this._ToggleRowVisibility(this._$paymentOptionsContainer, shouldShowPaymentOptions); // Hide the deposit amount if necessary


      this._UpdateDepositOptionRowVisibility(status, depositDetails, amountPaid);
    }
  }, {
    key: "_ShouldShowPaymentOptions",
    value: function _ShouldShowPaymentOptions(depositDetails, invoiceTotal, balanceDue, amountPaid) {
      return depositDetails.hasDepositAmount && invoiceTotal > 0 && !(depositDetails.depositTotal === balanceDue && amountPaid === 0) && balanceDue > 0;
    }
  }, {
    key: "_UpdateTotalCostDisplay",
    value: function _UpdateTotalCostDisplay() {
      var invoiceTotal = this._InvoiceData.invoiceTotal;

      if (this._$totalCost) {
        var totalCost = this._somePaid ? this._balanceDue : invoiceTotal;
        this._$totalCost.innerHTML = totalCost.toFixed(2);
      }

      if (this._$totalCostLabel) {
        var labelText = this._somePaid ? this._i18n.productRemainingBalanceLabel : this._i18n.totalCostOptionDescription;
        this._$totalCostLabel.textContent = labelText;
      }
    }
  }, {
    key: "_GetPaymentDetails",
    value: function _GetPaymentDetails() {
      var amountToPay;
      var paymentOption;

      if (this._$paymentOptionsContainer.style.display === "none") {
        amountToPay = parseFloat(this._InvoiceData.balanceDetails.balanceDue);
        paymentOption = "full";
      } else {
        var selectedOption = this._GetSelectedPaymentOption();

        if (!selectedOption) {
          this.SetMessage("danger", this._i18n.selectPaymentOptionPrompt);
          return {
            amountToPay: null,
            paymentOption: null
          };
        }

        amountToPay = this._GetSelectedPaymentAmount(selectedOption);
        paymentOption = selectedOption.value;
      }

      amountToPay = parseFloat(amountToPay.toFixed(2));
      return {
        amountToPay: amountToPay,
        paymentOption: paymentOption
      };
    }
    /**
     * Checks if deposit is requested based on the condition that at least one of the
     * detailItems is not a sub-item (isSubItem: false).
     * @returns {boolean} The value of depositRequested if the condition is met, otherwise false.
     */

  }, {
    key: "_CheckDepositRequested",
    value: function _CheckDepositRequested() {
      if (!this._InvoiceData || !Array.isArray(this._InvoiceData.detailItems)) {
        return false;
      }

      var isDepositNeededForNonSubItems = this._InvoiceData.detailItems.some(function (item) {
        return !item.isSubItem && item.depositRequested;
      });

      return isDepositNeededForNonSubItems;
    }
  }, {
    key: "_GeneratePaymentValidationConstraints",
    value: function _GeneratePaymentValidationConstraints() {
      // Deduce the minimum amount based on whether the deposit has been paid or any amount has been paid.
      var isAnyAmountPaid = this._somePaid;
      var isDepositPaid = this._InvoiceData.depositDetails.isDepositPaid;
      var minimumAmount = isDepositPaid || isAnyAmountPaid ? 1 : parseFloat(this._$depositAmount.textContent); // Set minimumDeposit to 0 if the deposit has already been paid, otherwise use the value from depositAmount.

      var minimumDeposit = isDepositPaid ? 0 : parseFloat(this._$depositAmount.textContent); // Define constraints for payment validation.

      var constraints = {
        minimum: minimumAmount,
        maximum: this._balanceDue,
        // Determine if a deposit is required; it's not required if any amount has been paid or the deposit has already been paid.
        isDepositRequired: !isAnyAmountPaid && !isDepositPaid && this._InvoiceData.status !== 2,
        minimumDeposit: minimumDeposit,
        status: this._InvoiceData.status
      };
      return constraints;
    }
    /**
     * Updates the page content by setting the page title and instructions.
     * @param {string} titleKey The key for the title text in the internationalization object.
     * @param {string} subtitleKey The key for the subtitle text in the internationalization object.
     */

  }, {
    key: "_UpdatePageTitleContent",
    value: function _UpdatePageTitleContent(titleKey, subtitleKey) {
      // Retrieve the localized strings using the provided keys and update the UI elements.
      this._$pageTitle.innerHTML = this._i18n[titleKey];
      this._$pageInstructions.innerHTML = this._i18n[subtitleKey];
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Invoice Details & Payment",
        tag: "mpp-checkout",
        configurationItems: [{
          name: "Payment Processor (Vendor) URL",
          attribute: "paymentprocessortargeturl",
          description: "URL that defines the path for the Payment Vendor handoff. It can be a relative or fully qualified URL and is provided by the Payment Vendor.",
          required: true,
          type: "url"
        }, {
          name: "Back to Event Target URL",
          attribute: "backtoeventtargeturl",
          description: "URL that defines the navigation path back to the Event Details Widget. It can be a relative or fully qualified URL.",
          required: true,
          type: "url"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["paymentprocessortargeturl", "backtoeventtargeturl", "receipttemplateid"];
    }
  }]);

  return MppCheckout;
}(ComponentBase);
MppCheckout.registerComponent(MppCheckout.WidgetDetails.tag, MppCheckout);